// Import Packages
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from "react-router-dom";

// Import Material UI
import { Button, ButtonGroup, Checkbox } from "@material-ui/core/";
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';

// Import Pages
import VariablePicker from '../../FlowConfigurationInputs/VariablePicker/VariablePicker';
import FieldLabel from '../../FlowConfigurationInputs/FieldLabel/FieldLabel';
import Stop from '../../FlowConfigurationForms/Stop/Stop/Stop';
// Import CSS
import './EventConfiguration.css';
import { CheckIfFlowUpdated } from "../../../helpers/helper";
import { useRecoilState, useRecoilValue, useSetRecoilState } from "recoil";
import { activeAutom, activeTab, changedFields, defaultItems, initialActions, saveAvailable } from "../../../recoil-store/recoil-state";

// Import Icons
import CreateAutom from "../../../assets/icons/CreateAutom";

/**
 * @Description This function lets you return component according to the name of the incoming action.
 * @Param       value - string
 * @Param       children - components
 * @Param       onChange - function
 * @Returns     Component
 * @Author      ibrahim AKIN
 */
function EventConfiguration({ action, setField, variables, setOpenVariable, setDialog, setDetailTabs, setTabFilter, justContinue }) {
    const initialActionsData = useRecoilValue(initialActions);
    const setSaveAvailable = useSetRecoilState(saveAvailable);
    const setChangeFields = useSetRecoilState(changedFields);
    const changedFieldsState = useRecoilValue(changedFields);
    const { t, i18n } = useTranslation();
    const label = 'CONTENT.CONFIGURATION-FORM.EVENT-CONFIGURATION.';
    // const options = {
    //     checkboxes: { label: label + 'CATCH-ERROR' }
    // }
    const initial = {
        errorReaction: { value: 'no' },
        numberOfRetries: { value: 1 },
        retryDuration: { value: 5000 },
        afterRetry: { value: 'continue' },
        errorFlow: { value: false }
    }
    const [state, setState] = useState(initial);
    // const [errorCatching, setErrorCatching] = useState();

    // useEffect(() => {
    //     if (action.item_id) {
    //         // if (action.fields.errorCatching?.value) {
    //         //     setErrorCatching(true);
    //         // } else {
    //         //     setErrorCatching(false);
    //         //     delete action.fields.errorObject;
    //         // }
    //     }
    // }, [action.item_id]);

    // useEffect(() => {
    //     if (action.item_id) {
    //         if (!errorCatching && action.fields.errorObject) {
    //             console.log('errorObject aldıııı')
    //             delete action.fields.errorObject;
    //         }
    //     }
    // }, [errorCatching]);

    useEffect(() => {
        const init = (a) => {
            if (action.fields[a]) { state[a] = action.fields[a]; }
            else { action.fields[a] = initial[a]; state[a] = initial[a]; if (setField) { setField(a, initial[a]) } }
        };
        const fields = ['errorReaction', 'numberOfRetries', 'retryDuration', 'afterRetry', 'errorFlow'];
        for (const i of fields) { init(i); }
        setState({ ...state });
    }, [action]);

    const handleChange = (e, name, isRequired = false) => {
        let newValue;

        if (name === 'switch') {
            action.fields.numberOfRetries.isRequired = false;
            action.fields.retryDuration.isRequired = false;
            const field = initialActionsData[action.id]?.fields["errorReaction"];
            if (e.target.checked) {
                newValue = 'continue';
                action.fields.errorReaction = { value: 'continue' };
                state.errorReaction = { value: 'continue' };
            } else {
                newValue = 'no';
                action.fields.errorReaction = { value: 'no' };
                state.errorReaction = { value: 'no' };
                if (state.errorFlow.value) {
                    deleteErrorFlow()
                }
            }
            if (setField) {
                setField("errorReaction", action.fields.errorReaction)
            }
            const oldValue = !field ? undefined : field.value;
            CheckIfFlowUpdated("errorReaction", action, oldValue, newValue, setSaveAvailable, setChangeFields, changedFieldsState);
        } else {
            const field = initialActionsData[action.id]?.fields[name];
            newValue = name === "errorFlow" ? e.target.checked : e.target.value;
            let value = name === "errorFlow" ? e.target.checked : e.target.value;


            if (name === "numberOfRetries") {
                if (Number(value) > 60) {
                    value = 60;
                } else if (Number(value) < 1) {
                    value = 1;
                }
            } else if (name === "retryDuration") {
                if (Number(value) > 60000) {
                    value = 60000;
                } else if (Number(value) < 1) {
                    value = 1;
                }
            }


            action.fields[name] = { value, isRequired };
            state[name] = { value };
            if (setField) {
                setField(name, action.fields[name])
            }
            if (name === "errorFlow" && !value) {
                deleteErrorFlow(true)
            }
            if (value === 'retry') {
                //setErrorCatching(false);
                //delete action.fields.errorCatching
                //delete action.fields.errorObject;
            }
            const oldValue = !field ? undefined : field.value.toString();
            CheckIfFlowUpdated(name, action, oldValue, newValue, setSaveAvailable, setChangeFields, changedFieldsState);
        }
        setState({ ...state });

    };

    // const changeOnCatching = (v) => {
    //     if (!v.value) {
    //         delete action.fields.errorObject;
    //     }
    //     // setErrorCatching(v.value);

    // }

    const changeReaction = (value) => {
        const field = initialActionsData[action.id]?.fields["errorReaction"];
        const oldValue = !field ? undefined : field.value;
        CheckIfFlowUpdated("errorReaction", action, oldValue, value, setSaveAvailable, setChangeFields, changedFieldsState);

        action.fields.errorReaction.value = value

        action.fields.numberOfRetries.isRequired = value === "retry";
        action.fields.retryDuration.isRequired = value === "retry";

        if (value === 'retry') {
            action.fields.afterRetry = { value: "continue" };
            state.afterRetry = { value: "continue" }
        }
        else if (state.errorFlow.value) {
            deleteErrorFlow()
        }
        state.errorReaction = { value };
        setState({ ...state })
    };
    const createNewEhFlow = async () => {
        if (action.eh_flow) {
            let copyTabs
            setDetailTabs(tabs => {
                copyTabs = JSON.parse(JSON.stringify(tabs))
                return tabs
            })
            if (copyTabs) {
                const isTabFinded = copyTabs.find((tab) => tab.id === action.id)
                setTabFilter(action.id)
                if (!isTabFinded) {
                    setDetailTabs(e => [...e, { name: action.eh_flow?.tabName, color: action.eh_flow.tabColor, item: [], errorHandling: true, id: action.id }]);
                }
                return
            }
        }
        else if (action.eh_flow && !state.errorFlow?.value) {
            setDetailTabs(e => [...e, { name: action.actionName, color: '#FFF', item: [], errorHandling: true, id: action.id }]);
            return
        }
        setDialog({ from: "ehFlow", item: action })
        // let copyAutom
        // setAutomDetail((autom) => {
        //     copyAutom = JSON.parse(JSON.stringify(autom))
        //     return autom
        // })
        // action.eh_flow = { ...copyAutom, items: defaultItems, id: action.id }
        // // setErrorHandlingAutomDetail({ ...copyAutom, items: defaultItems, errorHandlingId: action.id })
        // // setErrorHandlingAutomDetail({ items: defaultItems, errorHandlingId: action.id })
        // setErrorHandlingAutomDetails((pre) => [...pre, { ...copyAutom, items: defaultItems, errorHandlingId: action.id }])
        // setTabFilter(detailTabs.length + 1)
        // setDetailTabs(e => [...e, { name: action.actionName, color: '#FFF', item: [], errorHandling: true, id: action.id }]);
    }
    const deleteErrorFlow = (isAlreadyChangingState) => {
        let copyTabs
        setDetailTabs(tabs => {
            copyTabs = tabs
            copyTabs = copyTabs.filter((tab) => tab.id !== action.id)
            return copyTabs
        })
        if (!isAlreadyChangingState) {
            action.fields.errorFlow = { value: false };
            // state.errorFlow.value = false
            // setState({ ...state })
        }
        const errorHandlingIcon = document.getElementById(`error-icon-${action.id}`)
        if (errorHandlingIcon) {
            errorHandlingIcon.style.display = "none"
        }
    }

    return (
        <>
            <div className="event-conf-header">
                <div>{t(label + 'HEADER')}</div>
                <label className="switch small">
                    <input
                        type="checkbox" checked={state.errorReaction.value !== 'no'}
                        onChange={(e) => { handleChange(e, 'switch'); }}
                    />
                    <span className="slider round red" />
                </label>
            </div>
            {state.errorReaction.value !== 'no' &&
                <div className='event-conf-section'>
                    <ButtonGroup size="medium" aria-label="small outlined button group">
                        <Button
                            className={state.errorReaction.value === 'continue' ? "btn-gray" : ""}
                            id="button-group"
                            onClick={(e) => changeReaction('continue')}
                            variant="outlined"
                        >
                            {t(label + "CONTINUE-LABEL")}
                        </Button>
                        {
                            !justContinue &&
                            <Button
                                className={state.errorReaction.value === 'retry' ? "btn-gray" : ""}
                                id="button-group"
                                onClick={(e) => changeReaction('retry')}
                                variant="outlined"
                            >
                                {t(label + "RETRY-LABEL")}
                            </Button>
                        }

                    </ButtonGroup>

                    {state.errorReaction.value === 'continue' ?
                        <div className={`form-element`}>
                            <FieldLabel name={t(label + 'ASSIGN-ERROR-TO-VARIABLE')} />

                            <VariablePicker action={action} inputName="errorObject" variables={variables} setOpenVariable={setOpenVariable} filter="object" />
                            <small><em>{t('CONTENT.CONFIGURATION-FORM.VARIABLE-HELPER', { type: 'object' })}</em></small>
                            <div className='margin-top-8'>
                                <small><em>{t(label + 'ASSIGN-ERROR-DESCRIPTION')}</em></small>
                            </div>

                        </div> :
                        <div>
                            <div className={`event-retry`}>
                                <label>
                                    <FieldLabel name={t(label + 'N-TIMES')} is_required />
                                    <input type="number" min={0} value={state.numberOfRetries.value}
                                        onChange={(e) => { handleChange(e, 'numberOfRetries', true); }}
                                    />
                                </label>
                                <label>
                                    <FieldLabel name={t(label + 'DURATION')} is_required />
                                    <input type="number" min={0} value={state.retryDuration.value}
                                        onChange={(e) => { handleChange(e, 'retryDuration', true); }}
                                    />
                                    <span className='m-l-5'>{t(label + 'MS')}</span>
                                </label>
                            </div>

                            <RadioGroup className='event-conf-section-inside margin-top-13' value={state.afterRetry?.value}
                                onChange={(e) => { handleChange(e, 'afterRetry'); }}>
                                <div >
                                    <div style={{ margin: "0px" }} className={`form-element`}>
                                        <FieldLabel name={t(label + 'RETRY-INFO')} />
                                    </div>
                                    {
                                        setDialog &&
                                        <>
                                            <div>
                                                <FormControlLabel checked={state.errorFlow.value} label={t(label + 'RUN-ERROR-HANDLING-FLOW')}
                                                    control={<Checkbox onChange={(e) => handleChange(e, 'errorFlow')} color="default" size="small" />}
                                                />
                                            </div>
                                            {state.errorFlow.value &&
                                                <div className='form-element'>
                                                    <Button variant="outlined" className='error-handling-button-container' onClick={() => createNewEhFlow()}>
                                                        <div className='error-handling-button'>
                                                            <CreateAutom fill={"aliceblue"} stroke={"#80abd1"} plus={"#80abd1"} size={17} />
                                                            <div className='m-l-5'>{t(label + `${!action.eh_flow ? "CREATE-ERROR-HANDLING-FLOW" : "SHOW-ERROR-HANDLING-FLOW"}`)}</div>
                                                        </div>
                                                    </Button>
                                                </div>
                                            }
                                        </>

                                    }

                                    <div>
                                        <FormControlLabel
                                            value="continue" label={t(label + 'CONTINUE-ASSIGN')}
                                            control={<Radio color="default" size="small" />}
                                        />
                                    </div>
                                    <div>
                                        <FormControlLabel
                                            value="stop" label={t(label + 'STOP-RESPONSE')}
                                            control={<Radio color="default" size="small" />}
                                        />
                                    </div>

                                    {state.afterRetry.value === 'continue' &&
                                        <div className={`form-element`}>
                                            <FieldLabel name={t(label + 'ASSIGN-ERROR-TO-VARIABLE')} />
                                            <VariablePicker action={action} inputName="errorObject" variables={variables} setOpenVariable={setOpenVariable} filter="object" styles={{ backgroundColor: "#FCFCFC" }} />
                                            <small><em>{t('CONTENT.CONFIGURATION-FORM.VARIABLE-HELPER', { type: 'object' })}</em></small>
                                            <div className='margin-top-8'>
                                                <small><em>{t(label + 'ASSIGN-ERROR-DESCRIPTION')}</em></small>
                                            </div>
                                        </div>
                                    }

                                    {state.afterRetry.value === 'stop' &&
                                        <Stop action={action} setOpenVariable={setOpenVariable} variables={variables} fromEventConf={true} />
                                    }


                                </div>


                                {/* <div className={`event-conf-section margin-top-8 ${state.errorReaction.value !== 'retry' ? 'pasif-event' : ''}`} >
                                    <FormControlLabel
                                        value="retry" label={i18n.language === 'tr-TR' ?
                                            <span className='event-conf-title'><span className="event-error">HATA</span> oluşursa Eylemi Yeniden Dene</span> :
                                            <span className='event-conf-title'>Retry Action if <span className="event-error">ERROR</span> occurs</span>
                                        }
                                        control={<Radio color="default" size="small" />}
                                    />


                                </div> */}

                            </RadioGroup>
                        </div>
                    }
                </div>






                // <RadioGroup className='margin-top-13' value={state.errorReaction.value}
                //     onChange={(e) => { handleChange(e, 'errorReaction'); }}>
                //     <div className={`event-conf-section margin-top-8 ${state.errorReaction.value !== 'continue' ? 'pasif-event' : ''}`}>
                //         <FormControlLabel
                //             value="continue" label={i18n.language === 'tr-TR' ?
                //                 <span className='event-conf-title'><span className="event-error">HATA</span> oluşursa Akışa Devam <span className="default">{t(label + 'DEFAULT')}</span></span> :
                //                 <span className='event-conf-title'>Continue Flow if <span className="event-error">ERROR</span> occurs<span className="default">{t(label + 'DEFAULT')}</span></span>
                //             }
                //             control={<Radio color="default" size="small" />}
                //         />

                //         {/* < div className="form-element">
                //                     <Checkboxes onChange={changeOnCatching} action={action} inputName="errorCatching" options={options.checkboxes} style={{ fontSize: "12px", fontWeight: 600, color: '#202034' }} />
                //                 </div> */}

                //         <div className={`form-element  ${state.errorReaction.value !== 'continue' ? 'pasif-event' : ''}`}>
                //             {t(label + 'ASSIGN-ERROR-TO-VARIABLE')}
                //             <VariablePicker disabled={state.errorReaction.value !== 'continue'} action={action} inputName="errorObject" variables={variables} setOpenVariable={setOpenVariable} filter="object" />
                //             <small><em>{t('CONTENT.CONFIGURATION-FORM.VARIABLE-HELPER', { type: 'object' })}</em></small>
                //             <div className='margin-top-8'>
                //                 <small><em>{t(label + 'ASSIGN-ERROR-DESCRIPTION')}</em></small>
                //             </div>

                //         </div>

                //     </div>
                //     <div className={`event-conf-section margin-top-8 ${state.errorReaction.value !== 'retry' ? 'pasif-event' : ''}`} >
                //         <FormControlLabel
                //             value="retry" label={i18n.language === 'tr-TR' ?
                //                 <span className='event-conf-title'><span className="event-error">HATA</span> oluşursa Eylemi Yeniden Dene</span> :
                //                 <span className='event-conf-title'>Retry Action if <span className="event-error">ERROR</span> occurs</span>
                //             }
                //             control={<Radio color="default" size="small" />}
                //         />
                //         <div className={`event-retry  ${state.errorReaction.value !== 'retry' ? 'pasif-event' : ''}`}>
                //             <label>
                //                 {t(label + 'N-TIMES')}<br />
                //                 <input disabled={state.errorReaction.value !== 'retry'} type="number" min={0} value={state.numberOfRetries.value}
                //                     onChange={(e) => { handleChange(e, 'numberOfRetries'); }}
                //                 />
                //             </label>
                //             <label>
                //                 {t(label + 'DURATION')}<br />
                //                 <input disabled={state.errorReaction.value !== 'retry'} type="number" min={0} value={state.retryDuration.value}
                //                     onChange={(e) => { handleChange(e, 'retryDuration'); }}
                //                 />
                //                 <span>{t(label + 'MS')}</span>
                //             </label>
                //         </div>

                //     </div>

                // </RadioGroup>
            }


        </>
    );
}
export default EventConfiguration;
